<template>
  <v-col class="pa-6">
    <div v-if="!viewingOrder">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field class="input" label="Search..." prepend-inner-icon="mdi-magnify" rounded></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select style="max-width: 240px" class="input" label="Status" rounded :items="statusOptions"></v-select>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table style="width: 100%" :headers="headers" :items="desserts" :items-per-page="5"
          class="elevation-1 ml-4 mr-8">
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon color="#4390c0" @click="viewingOrder = true">mdi-eye</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingOrder">
      <ViewOrder @close="viewingOrder = false" />
    </div>
  </v-col>
</template>

<script>
import ViewOrder from "../components/ViewOrder.vue";

export default {
  data() {
    return {
      headers: [
        { text: "Order Number", value: "orderNo" },
        {
          text: "Name",
          value: "name",
        },
        { text: "Email Address", value: "email" },
        { text: "Status", value: "status" },
        { text: "Date", value: "date" },
        { text: "Action", value: "action" },
      ],
      desserts: [
        {
          orderNo: "92349",
          name: "Calvyn",
          email: "Calvyn610@gmail.com",
          status: "Pending",
          date: "0662030546",
          action: "",
        },
      ],
      viewingOrder: false,
      statusOptions: ['Pending', 'Completed'],
    };
  },
  components: {
    ViewOrder,
  },
};
</script>

<style scoped></style>